export const required = (value: string) => {
  if (!value) {
    return 'theFieldIsRequired';
  }

  return undefined;
};

export const invalidEmail = (value: string) => {
  if (!(/^[-!#$%&'+/=?^`{}|~\w]+(.[-!#$%&'+/=?^`{}|~\w]+)*@(?:[A-Z0-9](?:[A-Z0-9-]{0,61}[A-Z0-9])?.)+(?:[A-Z]{2,6}|[A-Z0-9]{2,})$/i.test(value))) {
    return 'emailIsInvalid';
  }

  return undefined;
};

// this function allows me to run more than one validation function
export const composeValidators = (...validators: Array<Function>) => (value: string) => (
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  validators.reduce((error, validator) => error ?? validator(value), undefined));
